function initCookies() {
    const approveCookiesButton = document.getElementById('eu-cookie-ok')
    const cookieBar = document.getElementById('eu-cookie-bar-notification')
    const url = "/eucookielawaccept"

    if (approveCookiesButton) {
        approveCookiesButton.addEventListener("click", () => {
            fetch(url, {
                method: 'POST',
            })
                .then(res => {
                    if (res.status === 200) {
                        return res.json()
                    } else {
                        console.warn('Cookie confirmation failed')
                    }
                }).then(data => {
                    if (data.stored === true) {
                        cookieBar.classList.add('fade-out-bottom')
                    } else {
                        console.warn('Error when handling cookies')
                    }
                })
        })
    }
}

export default initCookies